/** YouTube links can be filled in later — leave empty to show the placeholder. */
export const visualHubPageEn = {
  eyebrow: 'Watch & decide',
  title: 'HOLOL Visual Hub',
  subtitle:
    'Explore Holol’s vision, membership model, investment framework, media power, and 20 integrated services through short executive videos.',
  videoPlaceholder: 'Video coming soon',
  coreSectionsTitle: 'Core sections',
  servicesTitle: 'The 20 services system',
  servicesSubtitle:
    'A complete real estate services ecosystem — each service explained in a focused video brief.',
  sections: [
    {
      id: 'philosophy',
      icon: 'lightbulb',
      title: 'HOLOL Philosophy & Vision',
      subtitle:
        'A Journey into the Future of Real Estate: How HOLOL Redefines Investment and Market Dynamics.',
      videos: [
        {
          title: 'Full Executive Overview - 7 mins',
          videoUrl: 'https://www.youtube.com/watch?v=SJvMHYv2hqY',
        },
        {
          title: 'Quick Summary - 2 mins',
          videoUrl: 'https://www.youtube.com/watch?v=aCFcHUKma9Y',
        },
      ],
    },
    {
      id: 'membership',
      icon: 'workspace_premium',
      title: 'Smart Membership (Zero Commission Model)',
      subtitle:
        'The Zero-Commission Era: Transforming Traditional Brokerage into Sustainable Membership Value.',
      videos: [
        {
          title: 'Comprehensive Membership Guide',
          videoUrl: 'https://www.youtube.com/watch?v=qCuHrwQftAc',
        },
        {
          title: 'Membership Model in Brief',
          videoUrl: 'https://www.youtube.com/watch?v=Kab6D4bGA78',
        },
      ],
    },
    {
      id: 'investment',
      icon: 'trending_up',
      title: 'Investment & Financial Growth Model',
      subtitle:
        'Behind the Numbers: Financial Feasibility, Wealth Management, and Strategic Investment Opportunities.',
      videos: [
        {
          title: 'Full Financial Breakdown',
          videoUrl: 'https://www.youtube.com/watch?v=2Ri5Psu2tyk&t=1s',
        },
        {
          title: 'Investor Highlights',
          videoUrl: 'https://www.youtube.com/watch?v=8LOFsUzHF2E',
        },
        {
          title: 'Full Financial Breakdown (Second Presentation)',
          videoUrl: 'https://www.youtube.com/watch?v=dGcmETjRLqs',
        },
        {
          title: 'Investor Highlights (Second Presentation)',
          videoUrl: 'https://www.youtube.com/watch?v=A8frEAI2iaE',
        },
      ],
    },
    {
      id: 'media',
      icon: 'broadcast_on_personal',
      title: 'Media Power & Strategic Reach',
      subtitle:
        'Media as an Economic Engine: Leveraging Broadcast & Strategic Reach to Drive Market Demand.',
      videos: [
        {
          title: 'Media Power Strategy',
          videoUrl: 'https://www.youtube.com/watch?v=dgEfSeFmZuE',
        },
        {
          title: 'Media Power Strategy in Brief',
          videoUrl: 'https://www.youtube.com/watch?v=r0R8i3FvB8g',
        }
      ],
    },
  ],
  services: [
    { id: '01', icon: 'real_estate_agent', videoUrl: 'https://www.youtube.com/watch?v=fImmd4OP0uM' },
    { id: '02', icon: 'swap_horiz', videoUrl: 'https://www.youtube.com/watch?v=zBiKRQg1l-c' },
    { id: '03', icon: 'analytics', videoUrl: 'https://www.youtube.com/watch?v=k8K6HZ19MRw' },
    { id: '04', icon: 'campaign', videoUrl: 'https://www.youtube.com/watch?v=VpQXTxnmK44' },
    { id: '05', icon: 'account_balance', videoUrl: 'https://www.youtube.com/watch?v=gvjvGNWxzbM&pp=0gcJCaMLAYcqIYzv' },
    { id: '06', icon: 'construction', videoUrl: 'https://www.youtube.com/watch?v=DQKvQgi5q7s' },
    { id: '07', icon: 'design_services', videoUrl: 'https://www.youtube.com/watch?v=qMcqjzN2g-M' },
    { id: '08', icon: 'handyman', videoUrl: 'https://www.youtube.com/watch?v=Udyhap9YOA8' },
    { id: '09', icon: 'gavel', videoUrl: 'https://www.youtube.com/watch?v=yOKO55CX378' },
    { id: '10', icon: 'apartment', videoUrl: 'https://www.youtube.com/watch?v=8LOFsUzHF2E' },
    { id: '11', icon: 'pie_chart', videoUrl: 'https://www.youtube.com/watch?v=tRF2T6-pMxY' },
    { id: '12', icon: 'key', videoUrl: 'https://www.youtube.com/watch?v=ZPPBFiNqoTg' },
    { id: '13', icon: 'verified', videoUrl: 'https://www.youtube.com/watch?v=mg2FCM6GEzs' },
    { id: '14', icon: 'event', videoUrl: 'https://www.youtube.com/watch?v=WRFLqyPpxgw' },
    { id: '15', icon: 'school', videoUrl: 'https://www.youtube.com/watch?v=wxdxJL7hlt0' },
    { id: '16', icon: 'query_stats', videoUrl: 'https://www.youtube.com/watch?v=gkuFzPscFZ0&pp=0gcJCaMLAYcqIYzv' },
    { id: '17', icon: 'campaign', videoUrl: 'https://www.youtube.com/watch?v=VauLqnoOK40' },
    { id: '18', icon: 'public', videoUrl: 'https://www.youtube.com/watch?v=GmU7Rp8vbus' },
    { id: '19', icon: 'calculate', videoUrl: 'https://www.youtube.com/watch?v=EREEyWpJ2S0&pp=0gcJCaMLAYcqIYzv' },
    { id: '20', icon: 'flag', videoUrl: 'https://www.youtube.com/watch?v=deLP5NiA9us' },
  ],
};

export const visualHubPageAr = {
  eyebrow: 'شاهد و قرر',
  title: 'مركز حلول المرئي',
  subtitle:
    'استكشف رؤية حلول، نموذج العضوية، الإطار الاستثماري، القوة الإعلامية، ومنظومة الخدمات العشرين عبر فيديوهات تنفيذية مختصرة.',
  videoPlaceholder: 'الفيديو قريبًا',
  coreSectionsTitle: 'الأقسام الرئيسية',
  servicesTitle: 'منظومة الخدمات الـ 20',
  servicesSubtitle:
    'منظومة خدمات عقارية متكاملة — كل خدمة مشروحة في فيديو موجز ومركز.',
  sections: [
    {
      id: 'philosophy',
      icon: 'lightbulb',
      title: 'فلسفة مشروع حلول (المفهوم العام)',
      subtitle:
        'رحلة مع النموذج العقاري المستقبلي: كيف نُعيد تعريف الاستثمار والعلاقات العقارية.',
      videos: [
        {
          title: 'الشرح الشامل - 7 دقائق',
          videoUrl: 'https://www.youtube.com/watch?v=gLxAmW89Vyc',
        },
        {
          title: 'الإيجاز التنفيذي - دقيقتان',
          videoUrl: 'https://www.youtube.com/watch?v=vmxkWB3_2eE',
        },
      ],
    },
    {
      id: 'membership',
      icon: 'workspace_premium',
      title: 'العضوية الذكية (نموذج صفر عمولة)',
      subtitle:
        'عصر جديد بلا عمولات: كيف تحول نظام العضوية الذكية إلى قيمة مستدامة بدلاً من التكاليف المقتطعة.',
      videos: [
        {
          title: 'دليل العضوية التفصيلي',
          videoUrl: 'https://www.youtube.com/watch?v=hCBU5P6_fzY',
        },
        {
          title: 'موجز العضوية',
          videoUrl: 'https://www.youtube.com/watch?v=k0Y9FLFGJ8o',
        },
      ],
    },
    {
      id: 'investment',
      icon: 'trending_up',
      title: 'نموذج الاستثمار والنمو المالي',
      subtitle:
        'الأرقام تتحدث: قراءة في النموذج المالي، أبعاد الاستثمار، وإدارة الثروات مع نادي حلول.',
      videos: [
        {
          title: 'العرض المالي التفصيلي',
          videoUrl: 'https://www.youtube.com/watch?v=WCLkBjX63_8',
        },
        {
          title: 'ملخص الفرص الاستثمارية',
          videoUrl: 'https://www.youtube.com/watch?v=wGeMEFxyKT0',
        },
        {
          title: 'العرض المالي التفصيلي (العرض الثاني)',
          videoUrl: 'https://www.youtube.com/watch?v=vj1MQa2PjEo',
        },
        {
          title: 'ملخص الفرص الاستثمارية (العرض الثاني)',
          videoUrl: 'https://www.youtube.com/watch?v=AoLytjG9P1w',
        },
      ],
    },
    {
      id: 'media',
      icon: 'broadcast_on_personal',
      title: 'القوة الإعلامية والتسويق',
      subtitle:
        'الإعلام كمحرك للاقتصاد: كيف نسخر المنصات البرامجية والتلفزيونية لصناعة الطلب وتوجيه الأسواق.',
      videos: [
        {
          title: 'استراتيجية القوة الإعلامية',
          videoUrl: 'https://www.youtube.com/watch?v=-B1q9hKJTwc',
        },
        {
          title: ' ملخص استراتيجية القوة الإعلامية',
          videoUrl: 'https://www.youtube.com/watch?v=81OAfXaaKX8',
        }
      ],
    },
  ],
  services: [
    { id: '01', icon: 'real_estate_agent', videoUrl: 'https://www.youtube.com/watch?v=I1XR4SKLHHc' },
    { id: '02', icon: 'swap_horiz', videoUrl: 'https://www.youtube.com/watch?v=IYIwKNRcVvc' },
    { id: '03', icon: 'analytics', videoUrl: 'https://www.youtube.com/watch?v=5CMNFgBGoN4' },
    { id: '04', icon: 'campaign', videoUrl: 'https://www.youtube.com/watch?v=xDHGXlwYRsU' },
    { id: '05', icon: 'account_balance', videoUrl: 'https://www.youtube.com/watch?v=5_IZRkDsP_E' },
    { id: '06', icon: 'construction', videoUrl: 'https://www.youtube.com/watch?v=qT0KvxrxEpY' },
    { id: '07', icon: 'design_services', videoUrl: 'https://www.youtube.com/watch?v=o51MW9D8IGY' },
    { id: '08', icon: 'handyman', videoUrl: 'https://www.youtube.com/watch?v=fz9Lmbriy2M' },
    { id: '09', icon: 'gavel', videoUrl: 'https://www.youtube.com/watch?v=UILFaqbRZF0' },
    { id: '10', icon: 'apartment', videoUrl: 'https://www.youtube.com/watch?v=L00xH9GHnGw' },
    { id: '11', icon: 'pie_chart', videoUrl: 'https://www.youtube.com/watch?v=YO8gCD24dRQ' },
    { id: '12', icon: 'key', videoUrl: 'https://www.youtube.com/watch?v=89lw4bXiYv8' },
    { id: '13', icon: 'verified', videoUrl: 'https://www.youtube.com/watch?v=0b24tpLPAvc&pp=0gcJCaMLAYcqIYzv' },
    { id: '14', icon: 'event', videoUrl: 'https://www.youtube.com/watch?v=zdQOZoYABDU' },
    { id: '15', icon: 'school', videoUrl: 'https://www.youtube.com/watch?v=tFW-nyvrljw' },
    { id: '16', icon: 'query_stats', videoUrl: 'https://www.youtube.com/watch?v=C2RB2PQAKB0' },
    { id: '17', icon: 'campaign', videoUrl: 'https://www.youtube.com/watch?v=L_5l6BkN9PQ' },
    { id: '18', icon: 'public', videoUrl: 'https://www.youtube.com/watch?v=2NBxaNMB9UU' },
    { id: '19', icon: 'calculate', videoUrl: 'https://www.youtube.com/watch?v=LvDPKu_nJ3c' },
    { id: '20', icon: 'flag', videoUrl: 'https://www.youtube.com/watch?v=oXO5F2oQtlk' },
  ],
};
